module.exports = __webpack_public_path__ + "static/media/as_mask1.fa116b56.png";